import React from 'react';
import { Document } from '@contentful/rich-text-types';

import RichText from '../RichText';
import CollapsibleContainer from './CollapsibleContainer';
import { Icon } from '@greenlightme/ui/dist/v2';
import cx from 'classnames';

interface Props {
  title: string;
  content?: Document;
  isOpen: boolean;
  onClick?: () => void;
}

export function Collapsible({
  title,
  content,
  isOpen,
  onClick = () => null
}: Props) {
  const handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    // Check if the key pressed is 'Enter'
    if (event.key === 'Enter') {
      onClick();
    }
  };

  return (
    <div className="border-t border-solid border-[#d0d0d0] py-7 tablet:py-8 [&:last-child]:pb-0">
      <div
        className="flex cursor-pointer items-center justify-between"
        onClick={onClick}
        onKeyDown={handleKeyPress}
        tabIndex={0}
        data-testid="collapsible-item-title"
        role="button"
        aria-pressed={isOpen}
      >
        <div className="heading-3 tablet:!text-xl">{title}</div>
        <div className="pl-2 pt-2 tablet:pl-4 tablet:pt-1">
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onClick();
            }}
            data-testid="collapsible-btn"
            className="bg-transparent m-0 cursor-pointer appearance-none border-0 p-0 text-left"
          >
            <div className="h-5 w-5">
              <Icon
                fileName="ic_add"
                data-testid="glui-icon-add"
                className={cx(
                  'size-lg shrink-0 transition-transform duration-200',
                  isOpen ? 'rotate-45' : 'rotate-0'
                )}
                alt={isOpen ? 'Close section' : 'Open section'}
              />
            </div>
          </button>
        </div>
      </div>
      {isOpen && (
        <CollapsibleContainer>
          <div className="pt-3" data-testid="collapsible-content">
            {content && (
              <RichText
                data={content}
                bulletColor="green"
                data-testid="collapsible-body-text"
              />
            )}
          </div>
        </CollapsibleContainer>
      )}
    </div>
  );
}
